import { keyframes, styled, css } from 'styled-components';
import { BREAKPOINTS } from '../../constants/layout.mjs';
"use strict";
const reveal = keyframes`
  100% {
    opacity: 1;
  }
`;
const Reveal = styled.div`
  opacity: 0;
  background: ${({
  $backgroundColor
}) => $backgroundColor};
  ${({
  $animationDelay,
  $playAnimation,
  $playSpeed
}) => $playAnimation && css`
      animation: ${reveal} ${$playSpeed}s linear ${$animationDelay}s forwards;
    `};

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    opacity: 1;
    animation: unset;
  }
`;
export { Reveal };
//# sourceMappingURL=Reveal.styles.mjs.map
